import { isOriginAllowed } from './sanitizeUri';

const partnerSiteHostnames = [
  'skinmedica.consumer.allerewards.local',
  'skinmedica.dev.alle.com',
  'skinmedica.stage.alle.com',
  'skinmedica.demo.alle.com',
  'skinmedica.alle.com',
];

const allowedPartnerRedirectHostnames = [
  'localhost',
  'ecomm-pdp.internal.dev.alle.com',
  'skinmedica.com',
];

function isPartnerSite(): boolean {
  try {
    const parsed = new URL(window.location.origin);
    return partnerSiteHostnames.includes(parsed.hostname);
  } catch (e) {
    /* empty */
  }
  return false;
}

// Todo: Pull from cache - https://adl-technology.atlassian.net/browse/PDP-302
function getPartnerRedirectUri(searchParams: URLSearchParams): string {
  try {
    const qp = searchParams.get('redirect_uri') || '';
    const url = new URL(qp);
    if (allowedPartnerRedirectHostnames.includes(url.hostname)) {
      return url.toString();
    }
  } catch {
    /* empty */
  }
  return document.referrer;
}

function getAlleUrl(): string {
  try {
    if (!isPartnerSite()) {
      return 'https://alle.com';
    }
    const { protocol, hostname } = window.location;

    const parts = hostname.split('.');

    // Drop the first subdomain
    const strippedHost = parts.slice(1).join('.');

    // Add port for local development
    if (strippedHost === 'consumer.allerewards.local') {
      return `${protocol}//${strippedHost}:3500`;
    }

    const url = `${protocol}//${strippedHost}`;
    if (isOriginAllowed(url)) {
      return url;
    } else {
      return 'https://alle.com';
    }
  } catch {
    /* empty */
  }
  return 'https://alle.com';
}

const PartnerIntegrations = {
  getAlleUrl,
  getPartnerRedirectUri,
  isPartnerSite,
};

export { PartnerIntegrations };
